const events = {
  // 模仿漏斗图： 首页 -> 机构详情页 -> 套餐详情页 -> 日期选择页 -> 提交订单页 -> 订单详情页 -> 支付成功 or 失败页 -> over
  mainProcess: {
    index: "个检首页",
    "org-detail": "机构详情",
    "package-detail-v2": "套餐详情",
    "apply-before": "日期选择",
    apply: "提交订单",
    "order-detail-v2": "订单详情",
    "pay-fail": "支付失败",
    "pay-success": "支付成功"
  } // 主要流程页面路径
};

//百度统计
document.write(
  unescape(
    "%3Cscript src='https://hm.baidu.com/hm.js%3Fd6412368da82f349e4982a2da90b9acb' type='text/javascript'%3E%3C/script%3E"
  )
);
